import comp from "./MultiSelectComponent";
export default comp;
